var _rect, _rect2, _path, _path2, _rect3, _rect4, _path3, _path4, _rect5, _path5, _path6, _path7, _rect6, _path8, _path9, _rect7, _rect8, _rect9, _rect10, _rect11, _path10, _rect12, _rect13, _path11, _path12, _path13, _path14, _rect14, _path15, _path16, _path17, _rect15, _rect16, _path18, _rect17, _path19, _path20, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _path21, _path22, _path23, _path24, _rect24, _rect25, _rect26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "qrcode",
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28876",
    "data-name": "Rectangle 28876",
    width: 110,
    height: 110,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28877",
    "data-name": "Rectangle 28877",
    width: 3.333,
    height: 3.333,
    transform: "translate(60 10)",
    fill: "#015e9a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_285999",
    "data-name": "Path 285999",
    d: "M73.333,16.667h3.333V10H70V6.667H66.666v10h6.667Z",
    fill: "#015e9a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286000",
    "data-name": "Path 286000",
    d: "M56.667,20h6.667v6.667h3.333V23.333h6.667V20H66.667V16.667H60V13.333H56.667V20Z",
    fill: "#015e9a"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28878",
    "data-name": "Rectangle 28878",
    width: 3.333,
    height: 3.333,
    transform: "translate(33.333 26.667)",
    fill: "#015e9a"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28879",
    "data-name": "Rectangle 28879",
    width: 3.333,
    height: 3.333,
    transform: "translate(66.667 26.667)",
    fill: "#015e9a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286001",
    "data-name": "Path 286001",
    d: "M73.333,30h3.333V23.333H73.333V30Z",
    fill: "#015e9a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286002",
    "data-name": "Path 286002",
    d: "M96.666,33.333H93.333v10h3.333V40H100V36.666h3.334V33.333H96.666Z",
    fill: "#015e9a"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28880",
    "data-name": "Rectangle 28880",
    width: 3.333,
    height: 3.333,
    transform: "translate(26.667 40)",
    fill: "#015e9a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286003",
    "data-name": "Path 286003",
    d: "M33.333,43.333h3.334V50H40v3.333H33.333v3.334H30V60h3.333v6.667h3.334V63.333H40V60H36.667V56.667H40V60h3.333v3.333h3.334V60H50V50H46.667v6.667H43.333v-10H50V33.333h3.333V46.667h3.334V50H53.333V60H50v3.333H46.667V70H50V66.667h3.333V63.333h3.334V56.667H60V53.333h3.333V50H60V36.667h3.333v10h3.334V40H80V33.333H76.667v3.334H70V33.333H63.333V26.667H60v6.666H56.667V20H53.333V13.333h3.334V10H53.333V6.667H50v6.666H46.667V6.667H43.333V10H40V6.667H33.333v10h3.334V20H33.333v3.333h3.334v3.334H40V30h3.333V20h3.334V16.667H50V20H46.667v3.333h6.666V30H50V26.667H46.667v6.666H43.333v3.334h3.334V40H43.333V36.667H40V40H36.667V36.667H40V30H36.667v3.333h-20v3.334H13.333V40H10V33.333H6.667V46.667H10V43.333h6.667V40h6.666V36.667H30V40h3.333Zm6.667-30h3.333v3.333H40Z",
    fill: "#015e9a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286004",
    "data-name": "Path 286004",
    d: "M86.666,40H90V33.333H86.666v3.334H83.333v6.666h3.333Z",
    fill: "#015e9a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286005",
    "data-name": "Path 286005",
    d: "M23.333,43.333H20v3.333h6.666V43.333Z",
    fill: "#015e9a"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28881",
    "data-name": "Rectangle 28881",
    width: 3.333,
    height: 3.333,
    transform: "translate(90 43.334)",
    fill: "#015e9a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286006",
    "data-name": "Path 286006",
    d: "M100,46.667V50H86.667v3.334h6.666V60h3.334V53.334H100V60h3.333V43.334H100Z",
    fill: "#015e9a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286007",
    "data-name": "Path 286007",
    d: "M13.333,50h3.333V46.667H10V50Z",
    fill: "#015e9a"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28882",
    "data-name": "Rectangle 28882",
    width: 3.333,
    height: 3.333,
    transform: "translate(26.667 46.667)",
    fill: "#015e9a"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28883",
    "data-name": "Rectangle 28883",
    width: 3.333,
    height: 3.333,
    transform: "translate(30 50)",
    fill: "#015e9a"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28884",
    "data-name": "Rectangle 28884",
    width: 3.333,
    height: 3.333,
    transform: "translate(60 56.667)",
    fill: "#015e9a"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28885",
    "data-name": "Rectangle 28885",
    width: 3.333,
    height: 3.333,
    transform: "translate(26.667 60)",
    fill: "#015e9a"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28886",
    "data-name": "Rectangle 28886",
    width: 3.333,
    height: 3.333,
    transform: "translate(90 60)",
    fill: "#015e9a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286008",
    "data-name": "Path 286008",
    d: "M23.333,66.667h3.333V63.334H23.333V56.667H30V53.334H23.333V50H20v3.334H16.666v3.333H13.333V53.334H10v3.333H6.666V60H20v3.334H6.666V76.667h6.667V70H20V66.667Z",
    fill: "#015e9a"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28887",
    "data-name": "Rectangle 28887",
    width: 3.333,
    height: 3.333,
    transform: "translate(63.334 63.333)",
    fill: "#015e9a"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28888",
    "data-name": "Rectangle 28888",
    width: 3.333,
    height: 3.333,
    transform: "translate(86.666 63.334)",
    fill: "#015e9a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286009",
    "data-name": "Path 286009",
    d: "M96.666,66.667H100V63.334H93.333v3.333Z",
    fill: "#015e9a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286010",
    "data-name": "Path 286010",
    d: "M33.333,66.667H26.666V70H30v3.334h3.333V66.667Z",
    fill: "#015e9a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286011",
    "data-name": "Path 286011",
    d: "M56.667,70H60v3.333h3.334V66.667H60V63.333H56.667V70Z",
    fill: "#015e9a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286012",
    "data-name": "Path 286012",
    d: "M90,70H83.333v3.334H76.666V70H73.333v3.334H70v3.333h3.334V80H70V93.334h3.334V90h3.333v3.334H73.333v3.333h3.333V100H80V90h3.334v10h3.333V96.667H90V93.334H86.666V90h6.667V86.667H90V83.334h3.334V76.667H100V73.334H96.666V70H93.333V66.667H90ZM86.666,86.667h-10v-10h10v10Z",
    fill: "#015e9a"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28889",
    "data-name": "Rectangle 28889",
    width: 3.333,
    height: 3.333,
    transform: "translate(100 66.667)",
    fill: "#015e9a"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286013",
    "data-name": "Path 286013",
    d: "M26.667,70H20v6.667H30V73.333H26.667Z",
    fill: "#015e9a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286014",
    "data-name": "Path 286014",
    d: "M40,70h3.333V63.333H40v3.334H36.667v6.666H40Z",
    fill: "#015e9a"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286015",
    "data-name": "Path 286015",
    d: "M66.666,73.333H70V70h3.334V66.666h3.333V70h6.667V66.666H80V63.333H76.666V60H73.333V56.666h3.333V60H80V56.666h3.334V60H90V56.666H86.666V53.333H83.333V50h3.333V46.666H83.333V43.333h-10V50h3.333V46.666H80V50H76.666v3.333h-10V60H70v6.666H66.666v6.667Z",
    fill: "#015e9a"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28890",
    "data-name": "Rectangle 28890",
    width: 3.333,
    height: 3.333,
    transform: "translate(63.333 73.334)",
    fill: "#015e9a"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28891",
    "data-name": "Rectangle 28891",
    width: 3.333,
    height: 3.333,
    transform: "translate(66.667 76.667)",
    fill: "#015e9a"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286016",
    "data-name": "Path 286016",
    d: "M63.333,83.333v3.333h3.333V80H63.333Z",
    fill: "#015e9a"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28892",
    "data-name": "Rectangle 28892",
    width: 3.333,
    height: 3.333,
    transform: "translate(80 80)",
    fill: "#015e9a"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286017",
    "data-name": "Path 286017",
    d: "M103.333,86.667V83.334H96.666V90H100V86.667Z",
    fill: "#015e9a"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286018",
    "data-name": "Path 286018",
    d: "M60,90H53.333V80h3.334v6.667H60V73.333H56.667v3.334H53.333V70H50v6.667H46.667V73.333H43.333V80H50v3.333H46.667v3.334H50V90H43.333V83.333H40v3.334H36.667V73.333H33.333v20H40v3.334h3.333V93.333H50v3.334H43.333V100h10v3.333H60V100H56.667V96.667H60V93.333h3.333V86.667H60Z",
    fill: "#015e9a"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28893",
    "data-name": "Rectangle 28893",
    width: 3.333,
    height: 3.333,
    transform: "translate(63.334 93.333)",
    fill: "#015e9a"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28894",
    "data-name": "Rectangle 28894",
    width: 3.333,
    height: 3.333,
    transform: "translate(36.667 96.667)",
    fill: "#015e9a"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28895",
    "data-name": "Rectangle 28895",
    width: 3.333,
    height: 3.333,
    transform: "translate(66.667 96.667)",
    fill: "#015e9a"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28896",
    "data-name": "Rectangle 28896",
    width: 3.333,
    height: 3.333,
    transform: "translate(33.333 100)",
    fill: "#015e9a"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28897",
    "data-name": "Rectangle 28897",
    width: 3.333,
    height: 3.333,
    transform: "translate(40 100)",
    fill: "#015e9a"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28898",
    "data-name": "Rectangle 28898",
    width: 3.333,
    height: 3.333,
    transform: "translate(73.333 100)",
    fill: "#015e9a"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286019",
    "data-name": "Path 286019",
    d: "M86.666,100v3.333h6.667V100h3.333V96.667H100V100h3.334V90H100v3.333H93.333v3.334H90V100Z",
    fill: "#015e9a"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286020",
    "data-name": "Path 286020",
    d: "M26.5,30H30V6.667H6.667V30H26.5ZM10.167,10.167H26.5V26.5H10.167Z",
    fill: "#015e9a"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286021",
    "data-name": "Path 286021",
    d: "M99.833,6.667H80V30h23.333V6.667Zm0,19.833H83.5V10.167H99.833Z",
    fill: "#015e9a"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_286022",
    "data-name": "Path 286022",
    d: "M10.167,80h-3.5v23.333H30V80H10.167ZM26.5,99.833H10.167V83.5H26.5Z",
    fill: "#015e9a"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28899",
    "data-name": "Rectangle 28899",
    width: 10,
    height: 10,
    transform: "translate(13.333 13.333)",
    fill: "#015e9a"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28900",
    "data-name": "Rectangle 28900",
    width: 10,
    height: 10,
    transform: "translate(86.666 13.333)",
    fill: "#015e9a"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28901",
    "data-name": "Rectangle 28901",
    width: 10,
    height: 10,
    transform: "translate(13.333 86.667)",
    fill: "#015e9a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.52caa786289d2b8ccac68827a4e23bc3.svg";
export { ForwardRef as ReactComponent };